module.exports = __webpack_public_path__ + "images/category_lp/art_work/assessment_achievements/6_685ac455877d191fafffe22eff07d335.jpg";